import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslationModule } from '@core/translation/translation.module';

// Inline "LüA: 10m × B: 3,5m × T: 2m" line shared by boat and berth rows in the wizard.
// Berths pass `lengthKey="bookingV2.berth.dim.length"` (berth length, not LüA) and their
// `maxDraft` as `depth`.
@Component({
    selector: 'booking-v2-dimensions',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TranslationModule],
    template: `{{ lengthKey() | translate }}: {{ length() | number:'1.0-2' }}{{ 'bookingV2.berth.properties.unit' | translate }} × {{ 'bookingV2.berth.dim.width' | translate }}: {{ width() | number:'1.0-2' }}{{ 'bookingV2.berth.properties.unit' | translate }} × {{ 'bookingV2.berth.dim.draft' | translate }}: {{ depth() | number:'1.0-2' }}{{ 'bookingV2.berth.properties.unit' | translate }}`,
})
export class BookingV2DimensionsComponent {
    readonly length = input<number | null>(null);
    readonly width = input<number | null>(null);
    readonly depth = input<number | null>(null);
    readonly lengthKey = input<string>('bookingV2.berth.dim.loa');
}
